import { useMutation, UseMutationOptions } from 'react-query';

import { publicExportsApi } from 'src/Services/API';
import { ChecklistSubmissionDto, CreateChecklistSubmissionDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useSubmitExportedChecklist = (
  options?: UseMutationOptions<
    ChecklistSubmissionDto,
    unknown,
    {
      token: string;
      checklistId: string;
      checklist: CreateChecklistSubmissionDto;
    }
  >
) => {
  return useMutation<
    ChecklistSubmissionDto,
    unknown,
    {
      token: string;
      checklistId: string;
      checklist: CreateChecklistSubmissionDto;
    }
  >(
    ['submit-exported-checklist'],
    async ({
      token,
      checklistId,
      checklist,
    }: {
      token: string;
      checklistId: string;
      checklist: CreateChecklistSubmissionDto;
    }) => {
      const response =
        await publicExportsApi.publicChecklistSubmissionsControllerCreatePublicChecklistSubmission(
          token,
          checklistId,
          checklist
        );
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('Export', 'submitChecklist');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
